import { LOCAL_STORAGE_MESSAGES } from '../constants/labels';
import * as LocalStorage from '../storages/local-storage';
export var get = function () {
    var value = LocalStorage.get(LOCAL_STORAGE_MESSAGES);
    if (value === null) {
        return [];
    }
    try {
        return JSON.parse(value);
    }
    catch (_a) {
        return [];
    }
};
export var save = function (messages) {
    try {
        return LocalStorage.set(LOCAL_STORAGE_MESSAGES, JSON.stringify(messages));
    }
    catch (_a) {
        return false;
    }
};
export var clear = function () {
    return LocalStorage.remove(LOCAL_STORAGE_MESSAGES);
};
//# sourceMappingURL=message-storage.js.map